import Cart from 'components/Cart'
import ItemList from 'components/ItemList'
import Layout from 'components/Layout'
import Navbar from 'components/Navbar'

function App () {
  return (
    <Layout>
      <Navbar />
      <ItemList />
        <Cart />
    </Layout>
  )
}

export default App

// https://lucid.app/lucidchart/72c920a2-c653-4c8c-aad8-3ddb880b765b/edit?invitationId=inv_3d0e8299-0737-4167-b00a-d4dc4e02d191&page=fLIdogm_myHX#
